import { EuiFlexGroup } from "@elastic/eui";
import styled from "styled-components";

export const TableFilterWrapper = styled(EuiFlexGroup)`
    .filter-entities__wrapper {
        border: 1px solid ${(props) => props.theme.default.euiColorLightShade};
    }

    .euiFilterGroup {
        &,
        .euiPopover__anchor .euiFilterButton {
            border: none;
        }
    }

    .filter-entities__result {
        padding: 5px 25px 0 5px;
        position: relative;

        .filter-entities__clear-all {
            position: absolute;
            right: 3px;
            top: 50%;
            transform: translate(0, -50%);

            &:hover {
                transform: translate(0, -50%);
            }
        }

        .euiBadge {
            margin-bottom: 5px;
        }
    }

    .filters-list__category {
        display: flex;
        justify-content: space-between;
    }
`;
